//import  MouseEvent from "react";
//import { useState }  from "react";

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


import SearchBar from '../modules/xxxSearchBar';
import ListWithHeader from '../modules/CardListWithHeader';
import React, { useState, useEffect  } from 'react';
import { CaretDown } from 'react-bootstrap-icons';

import UICloseButton from '../UIComponents/CloseButton';
import { Link45deg } from 'react-bootstrap-icons';
import { Container } from 'react-bootstrap';

import { GetDataFetch } from '../../hooks/DataFetch';

interface ListGroupProps {
    title: string;
    items: string[];
    onSelectItem: (item: string) => void;
}

/* Shared with Apps */
interface CategoryProps{
  groupid: string;
  parent_id: string | null;
  name: string;
  description: string;
}

function NavBar(){

    let [NavMenuItems, setNavItem] = useState([
        {title: "Our Story", url: "/about"}, 
        {title: "Quick Shop", url: "/inventory/featured"},
        /*{title: "Beverages", url: "#"},*/
        {title: "Search Inventory", url: "/inventory"}, 
        {title: "More", url: "#"}, 
        /*{title: "Contact Us", url: "/contact"}, 
        {title: "Forum", url: "/network"}*/
    ]);
    let [selectItem, setSelectedItem] = useState(-1)
    
    let [megaMenuState, setMegaMenuState] = useState(false);
    let [mmFeaturedState, setMmFeaturedState] = useState(false);
    let [mmBeverageState, setMmBeverageState] = useState(false);
    let [mmMoreState, setMmMoreState] = useState(false);


    const [categories, setCategoriesFilter] = useState(Array<CategoryProps>);

    const collapseMegaMenu = () => {
        //setMegaMenuState(false);
        //setMmFeaturedState(false);
        setMmBeverageState(false);
        setMmMoreState(false);
    }

    const expandMegaMenu = (index: number) => {
        //if(index === 1){setMegaMenuState(true); setMmFeaturedState(true)}

        //Adding later
        //if(index === 2){setMegaMenuState(true); collapseMegaMenu(); setMmBeverageState(true)}

        if(index === 3){setMegaMenuState(true); collapseMegaMenu(); setMmMoreState(true)}
    }

    const GetCategories = async ()  => {
        //Need a URL specfically for Nav Info
        const posturl = process.env.REACT_APP_API_URL + "/v1/catalogue/inventory";
        let response = await GetDataFetch({url: posturl, data: {}});

        //Handle a Non 200 response
        setCategoriesFilter(response.categories)
    };
    

  useEffect(() => {
    if (categories.length === 0) {
        //GetCategories();
    }
  }, [categories]);
    
    return (
        <> 
            <Row className="p-1 bg-white brand-secondary-color-border">
                <Col>
                    <div className="btn-group">
                        {
                            NavMenuItems.map((NavMenuItem, index) => (
                                <a href={NavMenuItem.url} 
                                key={index}
                                className={selectItem === index ? "btn brand-btn-primary-color text-font-body text-font-medium text-font-size-medium active" : "btn brand-btn-primary-color text-font-body text-font-medium text-font-size-small"} 
                                onClick={ () => expandMegaMenu(index)}>
                                    {NavMenuItem.title}
                                </a>
                            ))
                        }
                    </div>
                </Col>
            </Row>
                        
            { megaMenuState &&
                <Row className="brand-secondary-color mega-menu" onMouseOver={() => setMegaMenuState(true)}>
                    <Container>
                        <Row>
                            <Col xs={{span: 1}}>
                                <UICloseButton closefunc={setMegaMenuState} />
                            </Col>
                            <Col md={{span: 11}}>
                                <Row>
                                    { mmFeaturedState && 
                                        <>
                                        <Col>
                                            <ListWithHeader  title="Sale" items={[]}/>
                                        </Col>
                                        </>
                                    }
                                    { mmMoreState && 
                                        <>
                                        <Col>
                                            <ListWithHeader  title="Join Sunsetter's Community" title_url="https://sunsettersrichmond.sunsetliq.com/communities/groups/sunsetters-richmond/home" items={[]}/>
                                        </Col>
                                        <Col>
                                            <ListWithHeader  title="Bottle of The Month Club" title_url="https://bottleofthemonth.sunsetliq.com/" items={[]}/>
                                        </Col>
                                        <Col>
                                            <ListWithHeader  title="Special Requests" title_url="https://sunsetliquor.poplme.co/sunset/dash" items={[]}/>
                                        </Col>
                                        <Col>
                                        {/*
                                            categories.map((category, index) => (
                                                <div>
                                                <a href="">
                                                    {category.name}
                                                </a>
                                                </div>
                                            ))*/
                                        }
                                        </Col>
                                        
                                        
                                        </>
                                    }
                                    { mmBeverageState && 
                                        <>
                                            <Col md={{span: 2}}>
                                                <a href="/inventory" className="text-start text-font-body text-font-heavy"><Link45deg />Browse Inventory</a>
                                            </Col>
                                            <Col md={{span: 2}}>
                                                <ListWithHeader  title="Spirits" title_url="/inventory/search/spirits" items={[
                                                    {id: "vodka", text: "Vodka", url: "/inventory/search/vodka"},
                                                    {id: "whiskey", text: "Whiskey", url: "/inventory/search/whiskey"},
                                                    {id: "gin", text: "Gin", url: "/inventory/search/gin"},
                                                    {id: "rum", text: "Rum", url: "/inventory/search/rum"},
                                                    {id: "tequila", text: "Tequila", url: "/inventory/search/tequila"},
                                                    {id: "brandy", text: "Brandy", url: "/inventory/search/brandy"},
                                                    {id: "cognac", text: "Cognac", url: "/inventory/search/cognac"}
                                                    ]}/>
                                            </Col>
                                            <Col md={{span: 2}}>
                                                <ListWithHeader  title="Wines" title_url="/inventory/search/wines" items={[
                                                    {id: "red", text: "Red Wine", url: "/inventory/search/red-wine"},
                                                    {id: "white", text: "White Wine", url: "/inventory/search/white-wine"},
                                                    {id: "champagne", text: "Sparkling Wine", url: "/inventory/search/sparkling"},
                                                    {id: "sparkling", text: "Champagne", url: "/inventory/search/champagne"},
                                                    {id: "rose", text: "Rosé", url: "/inventory/search/rose"},
                                                    {id: "dessert", text: "Dessert Wine", url: "/inventory/search/dessert-wine"}
                                                    
                                                ]}/>
                                            </Col>
                                            <Col md={{span: 2}}>
                                                <ListWithHeader  title="Beer & Seltzers" items={[
                                                    {id: "ale", text: "Ale", url: "/inventory/search/ale"},
                                                    {id: "lae", text: "Lager", url: "/inventory/search/lager"}
                                                ]}/>
                                            </Col>
                                            <Col md={{span: 2}}>
                                                <ListWithHeader  title="Non Alcoholic" title_url="/inventory/search/na" items={[
                                                    {id: "ale", text: "Ale", url: "/inventory/search/non-alcoholic-ale"},
                                                    {id: "lager", text: "Lager", url: "/inventory/search/non-alcoholic-lager"}
                                                ]}/>
                                            </Col>
                                        </>
                                    }
                                    
                                    
                                    
                                </Row>


                            </Col>
                        </Row>
                        
                    </Container>
                </Row>
            }
        </>
    )
}

export default NavBar;